import { useUserInfo } from '@/features/auth/hooks/useUserInfo';

/**
 * Resolução do vínculo do usuário logado a um cliente federado (RN09).
 *
 * A marca vem do `federated` do `GET /auth/user-info` — o BFF é a única fonte
 * da elegibilidade (RN02, que não é só domínio de e-mail) e o token não
 * carrega a origem do acesso, então não há como o portal inferir isso.
 *
 * Enquanto o user-info está em voo, `isFederated` é `false` e `isLoading` é
 * `true`: quem esconde a Gestão de acessos deve aguardar `isLoading` em vez
 * de renderizar e remover depois, para não piscar uma funcionalidade que o
 * usuário federado não pode usar.
 *
 * @returns Whether the user belongs to a federated client, plus the loading flag
 * @since 1.0.0
 * @category Hooks
 */
export function useIsFederatedUser(): {
  isFederated: boolean;
  isLoading: boolean;
} {
  const { data, isLoading } = useUserInfo();

  return { isFederated: data?.federated === true, isLoading };
}
